export const CKEDITOR_COLOR_PALETTE = [
  { color: '#ffffff', label: 'Blanco', hasBorder: true },
  { color: '#f2f2f2', label: 'Gris claro', hasBorder: true },
  { color: '#808080', label: 'Gris' },
  { color: '#404040', label: 'Gris oscuro' },
  { color: '#000000', label: 'Negro' },
  { color: '#1A3D82', label: 'Azul nimbus' },
  { color: '#d06b64', label: 'Ladrillo' },
  { color: '#f83a22', label: 'Cardenal' },
  { color: '#fa573c', label: 'Fresas' },
  { color: '#ff7e24', label: 'Naranja' },
  { color: '#ffad46', label: 'Taxi' },
  { color: '#42d692', label: 'Menta' },
  { color: '#16a765', label: 'Helecho' },
  { color: '#7bd148', label: 'Espárrago' },
  { color: '#b3dc6c', label: 'Limón' },
  { color: '#fbe983', label: 'Arena', hasBorder: true },
  { color: '#fad165', label: 'Macarrones', hasBorder: true },
  { color: '#92e1c0', label: 'Espuma' },
  { color: '#9fe1e7', label: 'Piscina' },
  { color: '#9fc6e7', label: 'Vaquero' },
  { color: '#4986e7', label: 'Cielo' },
  { color: '#9a9cff', label: 'Terciopelo' },
  { color: '#b99aff', label: 'Dinosaurio' },
  { color: '#5f6368', label: 'Ratón' },
  { color: '#cabdbf', label: 'Montaña' },
  { color: '#cca6ac', label: 'Lombriz' },
  { color: '#f691b2', label: 'Chicle' },
  { color: '#cd74e6', label: 'Lluvia' },
  { color: '#a47ae2', label: 'Berenjena' },
];
